import baseStyles from '@src/styles/base.scss';

export default (names, styles = null) => {

    if (names?.raw != undefined)
        return names.raw;

    if (names == null)
        return null;

    // eslint-disable-next-line no-param-reassign
    styles = styles ? Object.assign(baseStyles, styles) : baseStyles;

    if (Array.isArray(names))
        names = names.join(' '); // eslint-disable-line no-param-reassign

    return names.trim().split(' ')
        .map((name) => {

            // eslint-disable-next-line no-param-reassign
            name = name
                .replace('!', 'important:')
                .replace(/^(\w+):(.+)$/, '$2-$1')
                .replace(/(.+):([\w\-]+)$/, '$1--$2')
                .replace(/\//, 'div');

            if (styles[name] == undefined)
                throw new Error(`Class ${name} not found`);

            return styles[name];
        })
        .join(' ');
};